'use client';

import React, { useLayoutEffect, useRef } from 'react';

/**
 * This component loads the cqc widget script into the required location
 * @returns
 */
const CqcWidget = () => {
    const cqcWidgetRef = useRef<HTMLDivElement | null>(null);

    useLayoutEffect(() => {
        const script = document.createElement('script');
        script.src =
            'https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-10976213225&data-host=https://www.cqc.org.uk&type=location';
        script.async = true;

        cqcWidgetRef.current!.appendChild(script);

        return () => {
            cqcWidgetRef.current!.removeChild(script);
        };
    }, []);

    return <div ref={cqcWidgetRef} />;
};

export default CqcWidget;
